import Reflux from 'reflux';
import TeamData from 'shared/data/Team';

var async = { asyncResult: true },
  TeamViewActions = Reflux.createActions({
    populate: async,
    populateForGuest: async,
    savePhoto: {},
    setTabTitle: {},
  });

TeamViewActions.populate.listenAndPromise(TeamData.get);
TeamViewActions.populateForGuest.listenAndPromise(TeamData.getForGuest);

export default TeamViewActions;
